import { computed, toValue } from 'vue'

const WEEKDAYS = [
  { key: 'sunday' },
  { key: 'monday' },
  { key: 'tuesday' },
  { key: 'wednesday' },
  { key: 'thursday' },
  { key: 'friday' },
  { key: 'saturday' }
]

export function useWeekday(date, t) {

  return computed(() => {
    const day = toValue(date)?.getDay()
    if (WEEKDAYS[day]?.key) {
      return t(`day.${WEEKDAYS[day].key}`)
    }
    return undefined
  })
}
